import { useQuery } from "@tanstack/react-query";
import queryKey from "../../enumerations/queryKey";
import { apiGetFacebookLink } from "./service";

export const useGetFacebookLink = ({ options }) => {
  return useQuery(
    [queryKey.FACEBOOK_LINK],
    () =>
      apiGetFacebookLink({}).then((res) => {
        return res.data;
      }),
    {
      staleTime: 10 * (60 * 1000), //10mins
      cacheTime: 10 * (60 * 1000), //10mins
      ...options,
    },
  );
};
